import React, { Component } from 'react';
import SimpleLayout from './SimpleLayout';
import PasswordChange from '../components/login/PasswordChange';
import '../css/style.css';
import '../components/Home.css';

class PasswordChangeLayout extends Component {

    render(){
        return (
            <SimpleLayout>
                <PasswordChange />
            </SimpleLayout>              
        );
    }

}

export default PasswordChangeLayout;